// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"49e526e7","216":"c36cf236","255":"c36cf236","297":"a61830bd","427":"92e820d9","590":"e6864bee","659":"c36cf236","919":"f0ccba7b","920":"c36cf236","956":"28ef5c91"}[chunkId] + ".chunk.css";
};